import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS } from "./api-base"
import { getESGReqHeader } from "./tool-service";

//產品碳足跡係數 索引查詢
export const queryCarbonCoefficientIndex = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050301'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050301")}`, method: 'post', data: ReqBody })
}

export const queryCarbonCoefficientDetail= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050302'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050302")}`, method: 'post', data: ReqBody })
}

export const queryCarbonCoefficientById= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050303'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050303")}`, method: 'post', data: ReqBody })
}

// procuct info list
export const queryCompanyProduct= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040404'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040404")}`, method: 'post', data: ReqBody })
}
// procuct info detail
export const queryCompanyProductDetail= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040405'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040405")}`, method: 'post', data: ReqBody })
}

// list
export const queryCarbonFootprintList= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050310'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050310")}`, method: 'post', data: ReqBody })
}

//detail
export const queryCarbonFootprintDetail= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050311'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050311")}`, method: 'post', data: ReqBody })
}

// create footprint item before
export const F1050312Before= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050312'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050312",true)}`, method: 'post', data: ReqBody })
}
// create footprint item before
export const createFootprintItem= async (formData) => {
    return await apiS({ url: `/${getTxtIdMapperPath("F1050312")}`, method: 'post', data: formData })
}

// update footprint item before
export const updateFootprintItem= async (formData) => {
    return await apiS({ url: `/${getTxtIdMapperPath("F1050313")}`, method: 'post', data: formData })
}

export const deleteFootprintItem= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050314'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050314")}`, method: 'post', data: ReqBody })
}

//pcrreportlist
export const queryPcrReportList= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050305'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050305")}`, method: 'post', data: ReqBody })
}

// query carbonfootprintdata
export const queryCarbonFootprintData= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050315'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050315")}`, method: 'post', data: ReqBody })
}
// add carbonfootprintdata
export const createCarbonFootprintData= async (formData) => { 
    return await apiS({ url: `/${getTxtIdMapperPath("F1050317")}`, method: 'post', data: formData })
}

export const F1050317Before= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050317'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050317",true)}`, method: 'post', data: ReqBody })
}

export const queryCarbonDataIdInfo= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050316'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050316")}`, method: 'post', data: ReqBody })
}

// update carbonfootprintdata
export const updateCarbonFootprintData= async (formData) => { 
    return await apiS({ url: `/${getTxtIdMapperPath("F1050318")}`, method: 'post', data: formData })
}

export const deleteCarbonFootprintData= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050319'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050319")}`, method: 'post', data: ReqBody })
}

export const calcCarbonFootprintData= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050320'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050320")}`, method: 'post', data: ReqBody })
}

export const F105032001Before= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F105032001'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F105032001",true)}`, method: 'post', data: ReqBody })
}

export const updateSensitivityAnalysis= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F105032001'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F105032001")}`, method: 'post', data: ReqBody })
}

export const queryCarbonDataQualtity= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050321'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050321")}`, method: 'post', data: ReqBody })
}

export const updateCarbonDataQualtity= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050322'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050322")}`, method: 'post', data: ReqBody })
}

export const calcCarbonProductQualtity= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050323'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050323")}`, method: 'post', data: ReqBody })
}

export const queryDataQualtityMatrix= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050324'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050324")}`, method: 'post', data: ReqBody })
}

export const exportCarbonFootprint = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050325'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050325")}`, method: 'post', data: ReqBody,responseType:'blob' },false,true)
}

export const queryCarbonFootprintChartData= async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050326'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050326")}`, method: 'post', data: ReqBody })
}

export const copyCarbonFootprint = async (reqBody = {}) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("F1050327"),
    ReqBody: reqBody,
  };
  return await apiS({ url: `/${getTxtIdMapperPath("F1050327")}`, method: "post", data: ReqBody });
};

//盤查報告清單查詢
export const carbonFootprintReportList= async (reqBody) => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050361'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050361")}`, method: 'post', data: ReqBody })
}

//產生報告書
export const createCarbonFootprintReport= async (reqBody) => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050362'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050362")}`, method: 'post', data: ReqBody })
}

//報告書編輯 f1050363
export const modifyCarbonFootprintReport = async (formData) => {
    return await apiS({ url: `/${getTxtIdMapperPath("F1050363")}`, method: 'post', data: formData })
}

//報告書刪除
export const deleteCarbonFootprintReport= async (reqBody) => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1050364'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1050364")}`, method: 'post', data: ReqBody })
}

//報告書狀態查詢
export const queryCarbonFootprintReportStatus= async (reqBody) => { 
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1010365'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1010365")}`, method: 'post', data: ReqBody })
}

// 下載碳足跡模板
export const downloadCarbonFootprintTemplateExcel = async (reqBody) => {
  let ReqBody = {
    ReqHeader: getESGReqHeader("f1050328"),
    ReqBody: reqBody,
  };
  return await apiS(
    { url: `/${getTxtIdMapperPath("f1050328")}`, method: "post", data: ReqBody, responseType: "blob" },
    false,
    true,
  );
};

// 匯入碳足跡模板
export const importCarbonFootprintTemplateExcel = async (formData) => {
  return await apiS({ url: `/${getTxtIdMapperPath("f1050329")}`, method: "post", data: formData });
};